import { Button, Stack, Typography } from '@mui/material';

import { OverflowTooltip } from '../tooltips/overflowTooltip';

export const ChangeableTextField = ({
  value,
  noValueButtonText = 'Select',
  hasValueButtonText = 'Change',
  onClick,
  placeholder,
}: {
  value?: string;
  noValueButtonText?: string;
  hasValueButtonText?: string;
  onClick: () => void;
  placeholder: string;
}) => {
  return (
    <Stack
      direction='row'
      gap='12px'
      alignItems='center'
      justifyContent='space-between'
      sx={{
        paddingLeft: '20px',
        paddingRight: '12px',
        height: '48px',
        border: '1px solid var(--mui-palette-divider)',
        borderRadius: '4px',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      {value ? (
        <OverflowTooltip text={value} />
      ) : (
        <Typography color='text.disabled'>{placeholder}</Typography>
      )}
      <Button variant={value ? 'text' : 'contained'}>
        {value ? hasValueButtonText : noValueButtonText}
      </Button>
    </Stack>
  );
};
